"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * AddButtonComponent
 *
 */
var react_1 = __importStar(require("react"));
var AddRounded_1 = __importDefault(require("@mui/icons-material/AddRounded"));
var ButtonComponent_1 = __importDefault(require("../FormComponents/ButtonComponent"));
var styles_1 = require("@mui/styles");
var commonTypes_1 = require("../../../shared/types/commonTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    addButton: {
        '& .MuiButton-startIcon': {
            marginLeft: 0,
            marginRight: 0,
        },
        '& .MuiButton-root': {
            borderColor: theme.palette.primary.main,
            border: '1px solid',
            minWidth: '48px',
            '&.Mui-disabled ': {
                borderColor: theme.palette.grey.A200,
            },
        },
    },
}); });
var AddButtonComponent = function (props) {
    var classes = useStyles();
    var dataDisplayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var activeEntity = react_redux_1.useSelector(crude_selector_1.getActiveEntity);
    var disabled = props.disabled ? props.disabled : dataDisplayMode === commonTypes_1.DataDisplayMode.edit;
    var _a = react_1.useState(props.display), display = _a[0], setDisplay = _a[1];
    var _b = react_1.useState(), entity = _b[0], setEntity = _b[1];
    react_1.useEffect(function () {
        activeEntity && setEntity(activeEntity);
    }, [activeEntity]);
    react_1.useEffect(function () {
        setDisplay(props.display);
    }, [props.display]);
    return (react_1.default.createElement("div", { style: { textAlign: 'right' }, className: classes.addButton }, display &&
        react_1.default.createElement(ButtonComponent_1.default, { disabled: disabled, onClick: function () { return props.onClick && entity && props.onClick(entity); }, color: 'primary', variant: 'text', startIcon: react_1.default.createElement(AddRounded_1.default, { fontSize: 'large' }) })));
};
exports.default = AddButtonComponent;
